export default "__VITE_ASSET__CfZbtC4X__"